import { render, staticRenderFns } from "./projectManager.vue?vue&type=template&id=384fa97c&"
import script from "./projectManager.vue?vue&type=script&lang=js&"
export * from "./projectManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports